<div class="question-panel">
  <div class="custom-answer__group custom-answer__group--value form-group mb-0" id="ca-example-7">
    @for (item of questions; track item; let index = $index) {
      <div class="custom-answer">
        <div class="custom-answer__title">
          <label>{{item.list_name}}</label>
        </div>
        <div class="custom-answer__percent">
          <input
            type="tel"
            maxlength="3"
            placeholder="0"
            class="form-control"
            [name]="uniqueControlName"
            [(ngModel)]="item.list_value"
            (blur)="saveValue()"
            >
            <span class="custom-answer__percent-indi">%</span>
          </div>
        </div>
      }
    </div>
    @if (showTotal) {
      <div class="question-panel__total">
        <div class="question-panel__total-name">
          <p>Total</p>
        </div>
        <div class="question-panel__total-amount">
          <p><span data-total="" [ngClass]=" totalAmount > 100 ? 'is-invalid' : '' ">{{totalAmount}}</span> of 100</p>
          <span class="question-panel__total-indi">%</span>
        </div>
      </div>
    }
  </div>
